import {bootstrapApp} from '@/appManager/bootstrap';
import {instantiateVueApp} from '@/appManager/vue';

(async () => {
    await bootstrapApp();        // Vuex + features klaar
    instantiateVueApp();         // Vue mount pas nu
})();
